import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';

import { useTestCall } from '../utils/useTestCall';
import Progress from '../Components/Progress';
import Results from '../Components/Results';
import { TEST_STEPS } from '../constants';
import Intro from '../Components/Intro';

function TestDetails({
  onClose,
  formatMessage,
  testCredentials,
  onStartVideoVisit,
  virtualCallEnabled,
  visitTestPerformed,
}) {
  const initStep = visitTestPerformed ? TEST_STEPS.PROGRESS : TEST_STEPS.INTRO;
  const [step, setStep] = useState(initStep);
  const {
    disabled,
    progress,
    results,
    stopTest,
    notFound,
    error,
  } = useTestCall(step, testCredentials, null);

  useEffect(() => {
    if (results || notFound) {
      setStep(TEST_STEPS.RESULTS);
    }
  }, [results, notFound]);

  const handleStartTestVisit = () => setStep(TEST_STEPS.PROGRESS);

  const handleStop = () => {
    stopTest();
    onClose();
  };

  const renderContent = () => {
    switch (step) {
      case TEST_STEPS.INTRO: {
        return (
          <Intro
            onStartVideoVisit={onStartVideoVisit}
            onStartTestVisit={handleStartTestVisit}
            formatMessage={formatMessage}
            virtualCallEnabled={virtualCallEnabled}
          />
        );
      }
      case TEST_STEPS.PROGRESS: {
        return (
          <Progress
            progress={progress}
            formatMessage={formatMessage}
            onClick={handleStop}
            disabled={disabled}
            error={error}
          />
        );
      }
      case TEST_STEPS.RESULTS: {
        return (
          <Results
            notFound={notFound}
            results={results}
            formatMessage={formatMessage}
            onStartVideoVisit={onStartVideoVisit}
            virtualCallEnabled={virtualCallEnabled}
          />
        );
      }
    }
  };

  return <div className="mt5">{renderContent()}</div>;
}

TestDetails.propTypes = {
  onClose: PropTypes.func,
  formatMessage: PropTypes.func,
  onStartVideoVisit: PropTypes.func,
  virtualCallEnabled: PropTypes.bool,
  testCredentials: PropTypes.object,
  visitTestPerformed: PropTypes.bool,
};

export default TestDetails;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/TestDetails/index.jsx